import { useFormikContext } from 'formik';
import { ChangeEvent } from 'react';
import { Col, Row } from 'react-bootstrap';
import AutocompleteV2 from '../../../../../component/AutocompleteObjectV2';
import LabelRequired from '../../../../../component/LabelRequired';
import TextField from '../../../../../component/TextField';
import { LEVEL, LOAI_PHONG } from '../../../../../utils/Constant';
import { getDepartmentsByOrganization, searchTermModels } from '../../../../../utils/ServicesUtils';

const ThongTinChung = () => {
	const { values, touched, errors, setFieldValue } = useFormikContext<any>();

	return (
		<div>
			<Row className="spaces pt-10">
				<Col>
					<LabelRequired label="Khoa điều trị" isRequired />
					<AutocompleteV2
						options={[]}
						searchFunction={getDepartmentsByOrganization}
						searchObject={{
							level: LEVEL.KHOA,
							type: LOAI_PHONG.DIEU_TRI,
						}}
						name="treatmentDept"
						onChange={(option) => setFieldValue('treatmentDept', option)}
						getOptionLabel={(option) => `${option.code} - ${option.name}`}
						value={values?.treatmentDept}
						touched={touched?.treatmentDept}
						errors={errors?.treatmentDept}
						menuPlacement="bottom"
						urlData='data.content'
						isSrcoll
						isSearchable
						labelSearch="keyword"
					/>
				</Col>
				<Col>
					<LabelRequired label="Phiếu khám chuyên khoa" />
					<AutocompleteV2
						options={[]}
						name="template"
						onChange={(option) => {
							setFieldValue('template', option);
							setFieldValue('jsonTemplate', option?.modelJson);
						}}
						value={values?.template}
						menuPlacement="bottom"
						searchFunction={searchTermModels}
						urlData="data.content"
						searchObject={{
							tag: 'pkbVaoVien',
							pageIndex: 1,
							pageSize: 999,
						}}
					/>
				</Col>
			</Row>

			<Row className="spaces pt-10">
				<Col xs={12}>
					<LabelRequired label="Lý do vào viện" />
					<TextField
						className="w-100 d-flex resize-none"
						name="treatmentReason"
						labelClassName="ms-0 min-w-145px"
						as="textarea"
						rows="5"
						value={values?.treatmentReason || ''}
						onChange={(e: ChangeEvent<HTMLInputElement>) => {
							setFieldValue('treatmentReason', e.target.value);
						}}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default ThongTinChung;
